import { ButtonStateEnum } from '@/features/ui/buttons/constants'

export const isInteractiveButtonState = (
    state: ButtonStateEnum
): state is ButtonStateEnum.Hovered | ButtonStateEnum.Pressed =>
    state === ButtonStateEnum.Hovered || state === ButtonStateEnum.Pressed
